/**
 * Meses de periodo en los que el plan Premium puede estar activo (selector + persistencia en Redux).
 * Fuera de esta lista se deshabilita el card Premium y se limpia su selección al cambiar el periodo.
 */
export const PREMIUM_ALLOWED_SELECTED_MONTHS: readonly number[] = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const isPremiumMonthSelectionInvalid = (months: number | null): boolean =>
    months === null || !PREMIUM_ALLOWED_SELECTED_MONTHS.includes(months);

/**
 * Mensajes de perfil incompleto (nombre/apellido). Se usan tanto en el carrito
 * (bloqueo de pago) como en la tab "Información del usuario" (aviso temprano).
 * Mantener una sola fuente de verdad para que ambos lugares sean consistentes.
 */
export const PROFILE_NOTICE_NAME_AND_LASTNAME =
    "Se requiere actualizar información de Nombres y Apellidos, por favor usar la opción 'Editar Perfil'.";
export const PROFILE_NOTICE_LASTNAME =
    "Se requiere actualizar información de Apellidos, por favor usar la opción 'Editar Perfil'.";
export const PROFILE_NOTICE_NAME =
    "Se requiere actualizar información de Nombres, por favor usar la opción 'Editar Perfil'.";
